var sliderinterval;
var slidertimeInterval;

function sliderResetSlider(){
   sliderfntExecuteSlide(0);
}

function sliderInitAutoSlider(time){
    slidertimeInterval=(time * 1000);
    sliderResetSlider();
    interval = setInterval('sliderfntExecuteSlide("next")',slidertimeInterval);
}

function sliderfntExecuteSlide(){
    sliderResetSlider();
}

function sliderSelectSlide(side){
    sliderfntExecuteSlide(side);
    clearInterval(sliderinterval);
    interval = setInterval('fntExecuteSlide("next")',slidertimeInterval);
}

function sliderfntExecuteSlide(side){
    let parentTarget = document.getElementById('sliderList');
    let elements = parentTarget.getElementsByTagName('li');
    let curElement, nextElement;

    for(var i=0; i<elements.length;i++){

        if(elements[i].style.opacity==1){
            curElement = i;
            break;
        }
    }
    if(side == 'prev' || side == 'next'){

        if(side=="prev"){
            nextElement = (curElement == 0)?elements.length -1:curElement -1;
        }else{
            nextElement = (curElement == elements.length -1)?0:curElement +1;
        }
    }else{
        nextElement = side;
        side = (curElement > nextElement)?'prev':'next';

    }

    elements[curElement].style.opacity=0;
    elements[curElement].style.zIndex =0;
    elements[nextElement].style.opacity=1;
    elements[nextElement].style.zIndex =1;
}